import * as React from "react";
import { Layout } from "react-admin";
import Menu from "./Menu";

const MyLayout = (props: any) => <Layout {...props} menu={Menu} />;

export default MyLayout;
